import { unstable_batchedUpdates } from 'react-dom';
// Shared ordered queue. Replay and optimistic dispatch remain synchronous.
let jobs = [], frame = null;
const owners = new Set();
export function flushSocketFrame() {
  if (frame !== null) { cancelAnimationFrame(frame); frame = null; }
  const pending = jobs; jobs = [];
  unstable_batchedUpdates(() => pending.forEach(job => { if (owners.has(job.owner)) job.run(); }));
}
const onVisibility = () => { if (document.hidden) flushSocketFrame(); };
export function createSocketFrameQueue() {
  const owner = {};
  if (!owners.size) document.addEventListener('visibilitychange', onVisibility);
  owners.add(owner);
  return {
    enqueue(run) {
      if (!owners.has(owner)) return;
      jobs.push({ owner, run });
      if (document.hidden || typeof requestAnimationFrame !== 'function') { flushSocketFrame(); return; }
      if (frame === null) frame = requestAnimationFrame(() => { frame = null; flushSocketFrame(); });
    },
    flush: flushSocketFrame,
    cancel() {
      owners.delete(owner); jobs = jobs.filter(job => job.owner !== owner);
      if (!owners.size) { document.removeEventListener('visibilitychange', onVisibility); if (frame !== null) cancelAnimationFrame(frame); frame = null; }
    },
  };
}
